import React from 'react';

const ResultsSortBar = ({ 
  resultsCount, 
  sortBy, 
  setSortBy 
}) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
      <span style={{ color: '#6b7280', fontSize: '14px' }}>
        {resultsCount} patents found
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <label style={{ fontSize: '13px', color: '#6b7280' }}>Sort by:</label>
        <select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          style={{
            padding: '6px 10px',
            borderRadius: '4px',
            border: '1px solid #d1d5db',
            fontSize: '13px',
            cursor: 'pointer',
            background: 'white'
          }}
        >
          <option value="relevance">Relevance</option>
          <option value="most_cited">Most Cited</option>
          <option value="newest">Newest First</option>
          <option value="oldest">Oldest First</option>
        </select>
      </div>
    </div>
  );
};

export default ResultsSortBar;
